// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Mobile } from '../../../../components/Responsive';
import { formValueSelector, getFormValues, isDirty } from 'redux-form';
import ProgressTabs from './ProgressTabs';
import { Route, Switch } from 'react-router-dom';
import { type Match } from 'react-router-dom';
import AboutTheCompany from './Forms/AboutTheCompany';
import CompanyDetails from './Forms/CompanyDetails';
import ContactDetails from './Forms/ContactDetails';
import MailingAddress from './Forms/MailingAddress';
import { loadMerchantApplication } from './reducer';
import {
  MerchantRegistrationFormDiv,
  MerchantRegistrationHeaderDiv
} from './RegistrationStyles';
import { type Values } from './handleSubmit';
import SectionLoader from '../../../../components/SectionLoader';
import { deleteFailedMerchant } from '../ImportCsv/reducer';
import { type Currency } from '../../../../utilities/types';

export type ProcessingVolumes = Array<{
  id: number,
  range: string
}>;
type Props = {
  loadMerchantApplication: () => void,
  loading: boolean,
  dirty: boolean,
  match: Match,
  processingVolumes: ProcessingVolumes,
  values: Values,
  website: ?string,
  deleteFailedMerchant: (failedMerchantId: number, showModal: ?boolean) => void,
  currencies: Currency[]
};

class RegistrationForms extends Component<Props> {
  componentDidMount() {
    this.props.loadMerchantApplication();
  }

  render() {
    if (this.props.loading) {
      return <SectionLoader />;
    }
    return (
      <>
        <MerchantRegistrationHeaderDiv>
          <h5>Register your merchants details in the form below</h5>
          <Mobile>
            <p>
              Our sign up form is a simple intuative way to go through the
              regitstration process and add merchants one by one.
            </p>
          </Mobile>
          <p>
            Once we approve a merchant application, your merchant will receive
            an email to accept the terms of service and set up a password for
            their account.
          </p>
        </MerchantRegistrationHeaderDiv>
        <MerchantRegistrationFormDiv>
          <ProgressTabs
            active={Number(this.props.match.params.step)}
            // diff_mailing_address={this.props.diff_mailing_address}
            values={this.props.values}
            dirty={this.props.dirty}
          />
          <Switch>
            <Route
              exact
              path="/merchants/registrations/form/1"
              render={routeProps => (
                <CompanyDetails
                  {...routeProps}
                  nextRoute="/merchants/registrations/form/2"
                  currencies={this.props.currencies}
                />
              )}
            />
            <Route
              exact
              path="/merchants/registrations/form/2"
              render={routeProps => (
                <MailingAddress
                  {...routeProps}
                  // diff_mailing_address={this.props.diff_mailing_address}
                  nextRoute="/merchants/registrations/form/3"
                />
              )}
            />
            <Route
              exact
              path="/merchants/registrations/form/3"
              render={routeProps => (
                <AboutTheCompany
                  {...routeProps}
                  processingVolumes={this.props.processingVolumes}
                  nextRoute="/merchants/registrations/form/4"
                  website={this.props.website}
                />
              )}
            />
            <Route
              exact
              path="/merchants/registrations/form/4"
              render={routeProps => (
                <ContactDetails
                  {...routeProps}
                  deleteFailedMerchant={this.props.deleteFailedMerchant}
                />
              )}
            />
          </Switch>
        </MerchantRegistrationFormDiv>
      </>
    );
  }
}

const selector = formValueSelector('verification');

const mapStateToProps = state => ({
  loading:
    state.merchants.merchantRegistrations.merchantRegistrationsForms.loading,
  processingVolumes:
    state.merchants.merchantRegistrations.merchantRegistrationsForms
      .processingVolumes,
  values: getFormValues('verification')(state) || {},
  dirty: isDirty('verification')(state),
  website: selector(state, 'company_detail_attributes.website'),
  currencies: Object.values(state.global.currencies)
});

const mapDispatchToProps = {
  loadMerchantApplication,
  deleteFailedMerchant
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationForms);
